// Cabinet UI only. User-authored content remains original unless explicitly translated.
const messages = {
  "Заполните ответы и передайте на проверку": { "en": "Complete the answers and submit for review", "az": "Cavabları doldurun və yoxlamaya göndərin" },
  "Проверьте сведения и подтвердите результат": { "en": "Review the evidence and confirm the result", "az": "Məlumatları yoxlayın və nəticəni təsdiqləyin" },
  "Эта оценка доступна только для просмотра": { "en": "This assessment is read-only", "az": "Bu qiymətləndirməyə yalnız baxmaq mümkündür" },
  "«Сохранить ответы» сохраняет текущую работу. Кнопка рядом завершает этап и требует отдельного подтверждения.": { "en": "Save answers saves your work. The adjacent button completes the stage and requires separate confirmation.", "az": "Cavabları saxla cari işi saxlayır. Yanındakı düymə mərhələni tamamlayır və ayrıca təsdiq tələb edir." },
  "Черновик заполняет его автор. Для продолжения обратитесь к сотруднику, создавшему оценку.": { "en": "Only the author can complete this draft. Contact the person who created the assessment.", "az": "Qaralamanı onun müəllifi doldurur. Davam etmək üçün qiymətləndirməni yaradan əməkdaşla əlaqə saxlayın." },
  "Для независимой проверки нужен другой специалист с полномочием подтверждения оценок.": { "en": "Independent review requires another specialist with permission to confirm assessments.", "az": "Müstəqil yoxlama üçün qiymətləndirmələri təsdiqləmək səlahiyyəti olan başqa mütəxəssis lazımdır." },
  "Ответов с выбранным состоянием:": { "en": "Answers with a selected status:", "az": "Vəziyyəti seçilmiş cavablar:" },
  "Заполните самооценку": { "en": "Complete your self-assessment", "az": "Özünüqiymətləndirməni doldurun" },
  "Выберите согласованную методологию, ответьте на вопросы и приложите свидетельства.": { "en": "Select the agreed methodology, answer the questions and provide evidence.", "az": "Razılaşdırılmış metodologiyanı seçin, sualları cavablandırın və sübutları əlavə edin." },
  "Передайте на проверку": { "en": "Submit for review", "az": "Yoxlamaya göndərin" },
  "Сохранение ответов не отправляет их аудитору. Используйте «Отправить на проверку».": { "en": "Saving answers does not send them to the auditor. Use Submit for review.", "az": "Cavabların saxlanması onları auditora göndərmir. Yoxlamaya göndər düyməsini istifadə edin." },
  "Посмотрите результат": { "en": "View the result", "az": "Nəticəyə baxın" },
  "После подтверждения откройте профиль. Для уточнения используйте обращение к аудитору.": { "en": "Open the profile after confirmation. Send a request to the auditor if you need clarification.", "az": "Təsdiqdən sonra profili açın. Dəqiqləşdirmə üçün auditora müraciət edin." },
  "Сервис временно не смог подтвердить выполнение запроса. Не закрывайте заполненную форму и повторите действие через минуту.": {
    "en": "The service could not confirm your request. Keep the completed form open and try again in a minute.",
    "az": "Xidmət sorğunun icrasını təsdiqləyə bilmədi. Doldurulmuş formanı bağlamayın və bir dəqiqədən sonra yenidən cəhd edin."
  },
  "Нет соединения с сервером.": {
    "en": "No connection to the server.",
    "az": "Serverlə əlaqə yoxdur."
  },
  "Сервер отвечает слишком долго. Попробуйте ещё раз.": {
    "en": "The server is taking too long to respond. Please try again.",
    "az": "Server gec cavab verir. Yenidən cəhd edin."
  },
  "Загрузка перевода…": {
    "en": "Loading translation…",
    "az": "Tərcümə yüklənir…"
  },
  "% · Актуальность:": {
    "en": "% · Currency:",
    "az": "% · Aktuallıq:"
  },
  ". Выберите методологию, согласованную с аудитором. Эта самооценка не заменит ответы текущего аудита и не изменит подтверждённый рейтинг.": {
    "en": ". Select the methodology agreed with your auditor. This self-assessment does not replace audit answers or change the confirmed rating.",
    "az": ". Auditorla razılaşdırılmış metodologiyanı seçin. Özünüqiymətləndirmə audit cavablarını əvəz etmir və təsdiqlənmiş reytinqi dəyişmir."
  },
  ". Предыдущий результат не изменён.": {
    "en": ". The previous result is unchanged.",
    "az": ". Əvvəlki nəticə dəyişməyib."
  },
  ". Свидетельства выбираются при независимой проверке; исходные данные и статусы аудита не изменяются.": {
    "en": ". Evidence is selected during independent review; original audit data and statuses remain unchanged.",
    "az": ". Sübutlar müstəqil yoxlama zamanı seçilir; auditin ilkin məlumatları və statusları dəyişmir."
  },
  ". Требуется разрешить противоречия; система не выбирает итог автоматически.": {
    "en": ". Resolve the conflict; the system does not choose a result automatically.",
    "az": ". Ziddiyyət həll edilməlidir; sistem nəticəni avtomatik seçmir."
  },
  ": есть несохранённые изменения": {
    "en": ": unsaved changes",
    "az": ": yadda saxlanılmamış dəyişikliklər var"
  },
  "· Актуальность:": {
    "en": "· Currency:",
    "az": "· Aktuallıq:"
  },
  "· Оценка №": {
    "en": "· Assessment #",
    "az": "· Qiymətləndirmə №"
  },
  "· версия": {
    "en": "· version",
    "az": "· versiya"
  },
  "Браузер не разрешил сохранить резервный черновик.": {
    "en": "The browser could not save a recovery draft.",
    "az": "Brauzer bərpa qaralamasını saxlaya bilmədi."
  },
  "В форме остались несохранённые изменения. Закрыть её? Черновик останется в этой вкладке.": {
    "en": "There are unsaved changes. Close the form? A recovery draft will remain in this tab.",
    "az": "Yadda saxlanılmamış dəyişikliklər var. Formanı bağlayaq? Qaralama bu vərəqdə qalacaq."
  },
  "Введённый вами перевод сохраняется рядом с оригиналом, не заменяет его и не считается автоматически проверенным.": {
    "en": "Your translation is stored alongside the original, does not replace it and is not automatically verified.",
    "az": "Tərcüməniz orijinalla yanaşı saxlanılır, onu əvəz etmir və avtomatik yoxlanmış sayılmır."
  },
  "Вопрос, изменения и подтверждающие сведения": {
    "en": "Question, changes and supporting information",
    "az": "Sual, dəyişikliklər və təsdiqedici məlumatlar"
  },
  "Восстановить черновик": {
    "en": "Restore draft",
    "az": "Qaralamanı bərpa et"
  },
  "Все обращения": {
    "en": "All requests",
    "az": "Bütün müraciətlər"
  },
  "Выберите версию": {
    "en": "Select a version",
    "az": "Versiyanı seçin"
  },
  "Выберите результат": {
    "en": "Select a result",
    "az": "Nəticəni seçin"
  },
  "Выбрать источники из аудита": {
    "en": "Select audit evidence",
    "az": "Audit sübutlarını seç"
  },
  "Дата наблюдения": {
    "en": "Observation date",
    "az": "Müşahidə tarixi"
  },
  "Дождитесь загрузки связанных свидетельств.": {
    "en": "Wait for linked evidence to load.",
    "az": "Əlaqəli sübutların yüklənməsini gözləyin."
  },
  "Документ, запись, интервью: укажите, что именно было проверено": {
    "en": "Document, record, interview: specify what was checked",
    "az": "Sənəd, qeyd, müsahibə: nəyin yoxlanıldığını göstərin"
  },
  "Загружаем данные организации…": {
    "en": "Loading organisation data…",
    "az": "Təşkilat məlumatları yüklənir…"
  },
  "Загружаем обращения…": {
    "en": "Loading requests…",
    "az": "Müraciətlər yüklənir…"
  },
  "Закрыть": {
    "en": "Close",
    "az": "Bağla"
  },
  "Запросить повторную проверку": {
    "en": "Request a reassessment",
    "az": "Təkrar yoxlama tələb et"
  },
  "Зафиксировать ответ": {
    "en": "Save final reply",
    "az": "Yekun cavabı saxla"
  },
  "Зафиксировать результаты проверки? Они попадут в профиль организации. Старые аудиты и их рейтинги не изменятся.": {
    "en": "Confirm these results? They will appear in the organisation profile. Previous audits and ratings remain unchanged.",
    "az": "Bu nəticələri təsdiqləyək? Onlar təşkilatın profilində görünəcək. Əvvəlki auditlər və reytinqlər dəyişməyəcək."
  },
  "Зрелость:": {
    "en": "Maturity:",
    "az": "Yetkinlik:"
  },
  "Исторический результат проверки": {
    "en": "Historical review result",
    "az": "Yoxlamanın tarixi nəticəsi"
  },
  "Исходная самооценка не перезаписывается. Зрелость будет рассчитана автоматически.": {
    "en": "The original self-assessment is preserved. Maturity is calculated automatically.",
    "az": "İlkin özünüqiymətləndirmə saxlanılır. Yetkinlik avtomatik hesablanır."
  },
  "Исходный текст ·": {
    "en": "Original text ·",
    "az": "İlkin mətn ·"
  },
  "Квалификация организации": {
    "en": "Organisation qualification",
    "az": "Təşkilatın kvalifikasiyası"
  },
  "Код области": {
    "en": "Scope code",
    "az": "Əhatə sahəsinin kodu"
  },
  "На": {
    "en": "As of",
    "az": "Tarix:"
  },
  "Название области": {
    "en": "Scope name",
    "az": "Əhatə sahəsinin adı"
  },
  "Найден несохранённый черновик:": {
    "en": "Recovery draft found:",
    "az": "Saxlanılmamış qaralama tapılıb:"
  },
  "Не более 20 источников на критерий.": {
    "en": "Maximum 20 sources per criterion.",
    "az": "Hər meyar üçün ən çox 20 mənbə."
  },
  "Не закрывайте вкладку. Введённые данные пока доступны на экране; повторите сохранение на сервер.": {
    "en": "Do not close the tab. Your entries are still on screen; retry saving to the server.",
    "az": "Vərəqi bağlamayın. Daxil edilmiş məlumatlar ekrandadır; serverdə saxlamağı təkrar edin."
  },
  "Не означает взаимозаменяемости организаций. Ресурсы и пригодность для задачи проверяются отдельно.": {
    "en": "This does not make organisations interchangeable. Resources and suitability are assessed separately.",
    "az": "Bu, təşkilatların bir-birini əvəz edə biləcəyini göstərmir. Resurslar və tapşırığa uyğunluq ayrıca yoxlanılır."
  },
  "Не подтверждено актуальными данными:": {
    "en": "Not supported by current evidence:",
    "az": "Aktual sübutlarla təsdiqlənməyib:"
  },
  "Не проверено": {
    "en": "Not checked",
    "az": "Yoxlanılmayıb"
  },
  "Недостаточно свидетельств": {
    "en": "Insufficient evidence",
    "az": "Sübutlar kifayət deyil"
  },
  "Неизменяемый результат на момент фиксации. Текущий профиль рассчитывается отдельно.": {
    "en": "Immutable result at confirmation time. The current profile is calculated separately.",
    "az": "Təsdiq anında dəyişməz nəticə. Cari profil ayrıca hesablanır."
  },
  "Несохранённые изменения": {
    "en": "Unsaved changes",
    "az": "Saxlanılmamış dəyişikliklər"
  },
  "Новая самооценка": {
    "en": "New self-assessment",
    "az": "Yeni özünüqiymətləndirmə"
  },
  "Обновить обращения": {
    "en": "Refresh requests",
    "az": "Müraciətləri yenilə"
  },
  "Обоснование / пояснение": {
    "en": "Rationale / explanation",
    "az": "Əsaslandırma / izah"
  },
  "Обращение": {
    "en": "Request",
    "az": "Müraciət"
  },
  "Обращение из уведомления показано первым, независимо от фильтра и страницы списка.": {
    "en": "The notification's request is shown first, regardless of filters or page.",
    "az": "Bildirişdəki müraciət filtr və səhifədən asılı olmayaraq birinci göstərilir."
  },
  "Обращение не меняет подтверждённые ответы и баллы. При одобрении повторной проверки создаётся новая пустая самооценка по той же версии методологии; старый результат остаётся в истории.": {
    "en": "A request does not change confirmed answers or scores. An approved reassessment creates a new blank self-assessment using the same methodology version; the old result stays in history.",
    "az": "Müraciət təsdiqlənmiş cavabları və balları dəyişmir. Təkrar yoxlama təsdiqlənərsə, eyni metodologiya versiyası ilə yeni boş özünüqiymətləndirmə yaradılır; əvvəlki nəticə tarixçədə qalır."
  },
  "Обращений в этом разделе пока нет.": {
    "en": "No requests in this section yet.",
    "az": "Bu bölmədə hələ müraciət yoxdur."
  },
  "Обращения": {
    "en": "Requests",
    "az": "Müraciətlər"
  },
  "Объективно неприменимо": {
    "en": "Objectively not applicable",
    "az": "Obyektiv olaraq tətbiq edilmir"
  },
  "Обязательное": {
    "en": "Mandatory",
    "az": "Məcburi"
  },
  "Обязательные несоответствия:": {
    "en": "Mandatory nonconformities:",
    "az": "Məcburi tələblər üzrə uyğunsuzluqlar:"
  },
  "Ожидает ответа": {
    "en": "Awaiting reply",
    "az": "Cavab gözlənilir"
  },
  "Ожидают ответа": {
    "en": "Awaiting reply",
    "az": "Cavab gözləyənlər"
  },
  "Он сохранён в этой вкладке для вашей учётной записи. Восстановите его и проверьте перед отправкой: данные на сервере могли измениться.": {
    "en": "It is saved in this tab for your account. Restore and review it before submission: server data may have changed.",
    "az": "Qaralama bu vərəqdə hesabınız üçün saxlanılıb. Göndərməzdən əvvəl bərpa edib yoxlayın: server məlumatları dəyişmiş ola bilər."
  },
  "Опубликованная методология": {
    "en": "Published methodology",
    "az": "Dərc olunmuş metodologiya"
  },
  "Оригинал ·": {
    "en": "Original ·",
    "az": "Orijinal ·"
  },
  "Оставить данные сервера": {
    "en": "Keep server data",
    "az": "Server məlumatlarını saxla"
  },
  "Ответ и обоснование": {
    "en": "Reply and rationale",
    "az": "Cavab və əsaslandırma"
  },
  "Ответ предоставлен": {
    "en": "Replied",
    "az": "Cavab verilib"
  },
  "Ответ специалиста ·": {
    "en": "Specialist's reply ·",
    "az": "Mütəxəssisin cavabı ·"
  },
  "Ответить": {
    "en": "Reply",
    "az": "Cavab ver"
  },
  "Ответы": {
    "en": "Answers",
    "az": "Cavablar"
  },
  "Ответы и результат": {
    "en": "Answers and result",
    "az": "Cavablar və nəticə"
  },
  "Открыть исходную оценку": {
    "en": "Open original assessment",
    "az": "İlkin qiymətləndirməni aç"
  },
  "Открыть повторную оценку": {
    "en": "Open reassessment",
    "az": "Təkrar qiymətləndirməni aç"
  },
  "Открыть самооценку": {
    "en": "Open self-assessment",
    "az": "Özünüqiymətləndirməni aç"
  },
  "Отправить на проверку": {
    "en": "Submit for review",
    "az": "Yoxlamaya göndər"
  },
  "Отправить на проверку? Исходные ответы сохранятся неизменными. Аудитор запишет свою оценку отдельно.": {
    "en": "Submit for review? Your original answers will be preserved. The auditor records an independent assessment.",
    "az": "Yoxlamaya göndərək? İlkin cavablarınız saxlanılacaq. Auditor öz qiymətləndirməsini ayrıca qeyd edəcək."
  },
  "Отправить обращение": {
    "en": "Send request",
    "az": "Müraciəti göndər"
  },
  "Отправка самооценки": {
    "en": "Submit self-assessment",
    "az": "Özünüqiymətləndirməni göndər"
  },
  "Оценка больше не доступна. Обновите страницу.": {
    "en": "This assessment is no longer available. Refresh the page.",
    "az": "Bu qiymətləndirmə artıq mövcud deyil. Səhifəni yeniləyin."
  },
  "Оценка изменилась. Закройте окно и откройте её снова; локальный черновик сохранится.": {
    "en": "The assessment has changed. Close and reopen it; your local draft is preserved.",
    "az": "Qiymətləndirmə dəyişib. Pəncərəni bağlayıb yenidən açın; yerli qaralama saxlanılacaq."
  },
  "Перевод автора на русский:": {
    "en": "Author's Russian translation:",
    "az": "Müəllifin rus dilinə tərcüməsi:"
  },
  "Перевод на русский (необязательно)": {
    "en": "Russian translation (optional)",
    "az": "Rus dilinə tərcümə (istəyə bağlı)"
  },
  "По этому запросу критериев нет.": {
    "en": "No matching criteria.",
    "az": "Uyğun meyar tapılmadı."
  },
  "Повторная проверка": {
    "en": "Reassessment",
    "az": "Təkrar yoxlama"
  },
  "Подтвердить": {
    "en": "Confirm",
    "az": "Təsdiqlə"
  },
  "Подтвердить оценку": {
    "en": "Confirm assessment",
    "az": "Qiymətləndirməni təsdiqlə"
  },
  "Подтверждение оценки": {
    "en": "Confirm assessment",
    "az": "Qiymətləndirmənin təsdiqi"
  },
  "Поиск критерия": {
    "en": "Find a criterion",
    "az": "Meyar axtar"
  },
  "Пока нет опубликованных методологий. Обратитесь к вашему аудитору.": {
    "en": "No published methodologies yet. Contact your auditor.",
    "az": "Hələ dərc olunmuş metodologiya yoxdur. Auditorunuzla əlaqə saxlayın."
  },
  "Пока они доступны только на экране.": {
    "en": "They are currently available only on screen.",
    "az": "Hazırda yalnız ekranda mövcuddur."
  },
  "Полнота:": {
    "en": "Completeness:",
    "az": "Tamlıq:"
  },
  "Последние подтверждённые наблюдения только по выбранной области и версии методологии.": {
    "en": "Latest confirmed observations for the selected scope and methodology version only.",
    "az": "Yalnız seçilmiş sahə və metodologiya versiyası üzrə son təsdiqlənmiş müşahidələr."
  },
  "Предыдущие": {
    "en": "Previous",
    "az": "Əvvəlki"
  },
  "Применимо — оценить": {
    "en": "Applicable — assess",
    "az": "Tətbiq edilir — qiymətləndir"
  },
  "Проверка зафиксирована. Исходная самооценка и результаты сохранены отдельно.": {
    "en": "Review confirmed. Original self-assessment and results are stored separately.",
    "az": "Yoxlama təsdiqlənib. İlkin özünüqiymətləndirmə və nəticələr ayrıca saxlanılır."
  },
  "Продолжить заполнение": {
    "en": "Continue editing",
    "az": "Doldurmağa davam et"
  },
  "Противоречащие подтверждения на одну дату:": {
    "en": "Conflicting confirmations on the same date:",
    "az": "Eyni tarixdə ziddiyyətli təsdiqlər:"
  },
  "Разделы кабинета": {
    "en": "Portal sections",
    "az": "Kabinet bölmələri"
  },
  "Резервный черновик сохранён в этой вкладке. На сервер изменения попадут только после сохранения формы.": {
    "en": "A recovery draft is saved in this tab. Changes reach the server only when you save the form.",
    "az": "Bərpa qaralaması bu vərəqdə saxlanılıb. Dəyişikliklər yalnız formanı saxladıqdan sonra serverə ötürülür."
  },
  "Результат": {
    "en": "Result",
    "az": "Nəticə"
  },
  "Решение": {
    "en": "Decision",
    "az": "Qərar"
  },
  "Самооценка сама по себе не повышает подтверждённый рейтинг. Проверку фиксирует независимый специалист.": {
    "en": "Self-assessment alone does not increase the confirmed rating. An independent specialist confirms the review.",
    "az": "Özünüqiymətləndirmə təsdiqlənmiş reytinqi artırmır. Yoxlamanı müstəqil mütəxəssis təsdiqləyir."
  },
  "Самооценка, проверенные результаты и обращения к аудитору. Доступны только данные вашей организации.": {
    "en": "Self-assessments, verified results and requests to the auditor. Only your organisation's data is accessible.",
    "az": "Özünüqiymətləndirmələr, yoxlanmış nəticələr və auditora müraciətlər. Yalnız təşkilatınızın məlumatları mövcuddur."
  },
  "Самооценка:": {
    "en": "Self-assessment:",
    "az": "Özünüqiymətləndirmə:"
  },
  "Самооценки и результаты": {
    "en": "Self-assessments and results",
    "az": "Özünüqiymətləndirmələr və nəticələr"
  },
  "Самооценок пока нет. Прежние аудиты доступны в разделе «Мои аудиты».": {
    "en": "No self-assessments yet. Previous audits remain in My audits.",
    "az": "Hələ özünüqiymətləndirmə yoxdur. Əvvəlki auditlər «Auditlərim» bölməsindədir."
  },
  "Свидетельства": {
    "en": "Evidence",
    "az": "Sübutlar"
  },
  "Сводный рейтинг · только управленческий обзор": {
    "en": "Overall rating · management overview only",
    "az": "Ümumi reytinq · yalnız idarəetmə icmalı"
  },
  "Связан аудит №": {
    "en": "Linked audit #",
    "az": "Əlaqəli audit №"
  },
  "Связанные свидетельства ·": {
    "en": "Linked evidence ·",
    "az": "Əlaqəli sübutlar ·"
  },
  "Следующие": {
    "en": "Next",
    "az": "Növbəti"
  },
  "Согласуйте с аудитором. Одинаковый код объединяет оценки одной площадки или процесса.": {
    "en": "Agree with your auditor. Use the same code for assessments of one site or process.",
    "az": "Auditorla razılaşdırın. Eyni sahə və ya prosesin qiymətləndirmələri üçün eyni koddan istifadə edin."
  },
  "Создана отдельная оценка №": {
    "en": "New separate assessment #",
    "az": "Yeni ayrıca qiymətləndirmə №"
  },
  "Создать самооценку": {
    "en": "Create self-assessment",
    "az": "Özünüqiymətləndirmə yarat"
  },
  "Состояние проверки": {
    "en": "Review status",
    "az": "Yoxlama statusu"
  },
  "Сохранить ответы": {
    "en": "Save answers",
    "az": "Cavabları saxla"
  },
  "Страница": {
    "en": "Page",
    "az": "Səhifə"
  },
  "Текущий профиль": {
    "en": "Current profile",
    "az": "Cari profil"
  },
  "Тип обращения": {
    "en": "Request type",
    "az": "Müraciət növü"
  },
  "Уточнение": {
    "en": "Clarification",
    "az": "Dəqiqləşdirmə"
  },
  "Уточнение / повторная проверка": {
    "en": "Clarification / reassessment",
    "az": "Dəqiqləşdirmə / təkrar yoxlama"
  },
  "Уточнить результат / наблюдение": {
    "en": "Clarify a result / observation",
    "az": "Nəticəni / müşahidəni dəqiqləşdir"
  },
  "Это исходная оценка; подтверждение выполняется отдельно.": {
    "en": "This is the original assessment; confirmation is separate.",
    "az": "Bu ilkin qiymətləndirmədir; təsdiq ayrıca aparılır."
  },
  "Это не автоматический допуск к работам.": {
    "en": "This is not automatic approval to perform work.",
    "az": "Bu, işlərin görülməsinə avtomatik icazə deyil."
  },
  "Язык исходного текста": {
    "en": "Original language",
    "az": "İlkin mətnin dili"
  },
  "не определена": {
    "en": "not determined",
    "az": "müəyyən edilməyib"
  },
  "Черновик самооценки": {
    "en": "Self-assessment draft",
    "az": "Özünüqiymətləndirmə qaralaması"
  },
  "На независимой проверке": {
    "en": "Under independent review",
    "az": "Müstəqil yoxlamadadır"
  },
  "Результат зафиксирован": {
    "en": "Result confirmed",
    "az": "Nəticə təsdiqlənib"
  },
  "Уточнение предоставлено": {
    "en": "Clarification provided",
    "az": "Dəqiqləşdirmə təqdim edilib"
  },
  "Повторная проверка одобрена": {
    "en": "Reassessment approved",
    "az": "Təkrar yoxlama təsdiqlənib"
  },
  "Повторная проверка отклонена": {
    "en": "Reassessment declined",
    "az": "Təkrar yoxlama rədd edilib"
  },
  "Достаточно подтверждений": {
    "en": "Sufficient evidence",
    "az": "Kifayət qədər sübut var"
  },
  "Обязательное требование не выполнено": {
    "en": "Mandatory requirement not met",
    "az": "Məcburi tələb yerinə yetirilməyib"
  },
  "Недостаточно подтверждения": {
    "en": "Insufficient confirmation",
    "az": "Təsdiq kifayət deyil"
  },
  "Критерии неприменимы": {
    "en": "Criteria not applicable",
    "az": "Meyarlar tətbiq edilmir"
  },
  "Нет критериев": {
    "en": "No criteria",
    "az": "Meyar yoxdur"
  },
  "B · Надёжность контрагента": {
    "en": "B · Counterparty reliability",
    "az": "B · Kontragentin etibarlılığı"
  },
  "G · Управление": {
    "en": "G · Management",
    "az": "G · İdarəetmə"
  },
  "S · Профессиональные процессы": {
    "en": "S · Professional processes",
    "az": "S · Peşəkar proseslər"
  },
  "Отмена": {
    "en": "Cancel",
    "az": "Ləğv et"
  },
  "Оценка": {
    "en": "Assessment",
    "az": "Qiymətləndirmə"
  },
  "Текущий профиль · подтверждённых оценок:": {
    "en": "Current profile · confirmed assessments:",
    "az": "Cari profil · təsdiqlənmiş qiymətləndirmələr:"
  },
  "Ответ на обращение": {
    "en": "Reply to request",
    "az": "Müraciətə cavab"
  },
  "Обращение по оценке": {
    "en": "Assessment request",
    "az": "Qiymətləndirmə üzrə müraciət"
  },
  "Перевод": {
    "en": "Translation",
    "az": "Tərcümə"
  },
  "Перевести сохранённый вопрос и ответы": {
    "en": "Translate saved question and answers",
    "az": "Saxlanılmış sualı və cavabları tərcümə et"
  },
  "Проверить перевод": {
    "en": "Review translation",
    "az": "Tərcüməni yoxla"
  },
  "Машинный перевод. Проверьте термины; оригинал сохранён.": {
    "en": "Machine translation. Check terminology; the original is preserved.",
    "az": "Maşın tərcüməsi. Terminləri yoxlayın; orijinal saxlanılıb."
  },
  "Перевод проверен человеком.": {
    "en": "Translation reviewed by a person.",
    "az": "Tərcümə insan tərəfindən yoxlanılıb."
  },
  "Сначала сохраните ответы.": {
    "en": "Save answers first.",
    "az": "Əvvəlcə cavabları saxlayın."
  },
  "Перевод устарел после изменения оригинала.": {
    "en": "The original changed; the translation is outdated.",
    "az": "Orijinal dəyişib; tərcümə köhnəlib."
  },
  "Вопрос": {
    "en": "Question",
    "az": "Sual"
  },
  "Требование": {
    "en": "Requirement",
    "az": "Tələb"
  },
  "Самооценка — свидетельства": {
    "en": "Self-assessment — evidence",
    "az": "Özünüqiymətləndirmə — sübutlar"
  },
  "Самооценка — пояснение": {
    "en": "Self-assessment — rationale",
    "az": "Özünüqiymətləndirmə — əsaslandırma"
  },
  "Проверка — свидетельства": {
    "en": "Review — evidence",
    "az": "Yoxlama — sübutlar"
  },
  "Проверка — пояснение": {
    "en": "Review — rationale",
    "az": "Yoxlama — əsaslandırma"
  },
  "Обоснование проверки перевода": {
    "en": "Translation review rationale",
    "az": "Tərcümə yoxlamasının əsaslandırılması"
  },
  "Сохранить проверенный перевод": {
    "en": "Save reviewed translation",
    "az": "Yoxlanmış tərcüməni saxla"
  }
};
export default messages;
